import React from "react";

const Marriage = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M12.692 29.757c-4.302-.243-7.728-3.82-7.728-8.183 0-4.52 3.677-8.197 8.196-8.197 2.021 0 3.962.742 5.465 2.089a8.205 8.205 0 012.732 6.108c0 1.953-.7 3.834-1.951 5.307a6.3 6.3 0 002.965.996 11.055 11.055 0 001.95-6.303c0-2.438-.772-4.753-2.232-6.696a11.206 11.206 0 00-4.465-3.535 11.023 11.023 0 00-3.047-.84c2.124-1.564 2.937-2.875 2.937-4.019A2.484 2.484 0 0013.16 4.85a2.484 2.484 0 00-4.353 1.635c0 1.144.813 2.455 2.938 4.02C6.257 11.2 2 15.9 2 21.573c0 6.154 5.006 11.16 11.16 11.16.85 0 1.686-.094 2.5-.28a13.108 13.108 0 01-2.968-2.697z"
            fill={fill}
        />
        <path className="u_fill"
            d="M22.84 10.414c-.85 0-1.686.094-2.5.28a13.113 13.113 0 012.968 2.697c4.302.243 7.728 3.82 7.728 8.183 0 4.52-3.677 8.197-8.196 8.197a8.178 8.178 0 01-5.465-2.089 8.205 8.205 0 01-2.732-6.108c0-1.953.701-3.835 1.951-5.307a6.301 6.301 0 00-2.965-.996 11.054 11.054 0 00-1.95 6.303c0 2.438.772 4.753 2.232 6.696a11.203 11.203 0 004.465 3.535c1.41.617 2.91.929 4.464.929 6.154 0 11.16-5.007 11.16-11.16 0-6.154-5.006-11.16-11.16-11.16z"
            fill={fill}
        />
    </svg>
);

export default Marriage;